import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Headphones } from "lucide-react";
import SectionHead from "../../components/shared/SectionHead";
import Button from "../../ui/Button";
import FaqItem from "./FaqItem";
import { FAQ_ITEMS } from "./faqItems";

export default function FAQ() {
  const { t } = useTranslation("landing");
  const [openKey, setOpenKey] = useState(FAQ_ITEMS[0].key); // اولین آیتم پیش‌فرض باز

  const toggle = (key) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  return (
    <section
      id="faq"
      className="scroll-mt-24 bg-canvas-2 py-16 sm:py-20 lg:py-24"
    >
      <div className="mx-auto max-w-container px-5 sm:px-7">
        <SectionHead
          eyebrow={t("faq.eyebrow")}
          title1={t("faq.title1")}
          titleGrad={t("faq.titleGrad")}
          subtitle={t("faq.sub")}
        />

        <div className="mx-auto max-w-[820px]">
          {/* Items */}
          <div className="flex flex-col gap-3.5">
            {FAQ_ITEMS.map((item, i) => (
              <FaqItem
                key={item.key}
                item={item}
                isOpen={openKey === item.key}
                onToggle={() => toggle(item.key)}
                index={i}
              />
            ))}
          </div>

          {/* Contact CTA */}
          <div className="mt-10 flex flex-col items-center gap-4 text-center">
            <p className="text-[13.5px] text-ink-soft sm:text-[14px]">
              {t("faq.sub")}
            </p>
            <Button as={Link} to="/login" variant="ghost" size="md">
              <Headphones className="h-4 w-4" />
              {t("faq.contactCta")}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}